import MenuItemSingle from './MenuItemSingle'

const MenuItem = ({menuItem, pages, currentCinema, homePages, overviewPages}) => {
    if(!menuItem || !currentCinema) {
        return ''
    }

    const { title, object, object_id, url, is_overview } = menuItem
    const elementorlink = 'page' === object ? pages[object_id].elementorlink : null
    const isHomeOrOverview = _.contains(homePages, url) || _.contains(overviewPages, url) ? true : false
    const showElementorlink = isHomeOrOverview || is_overview || currentCinema.website === url ? null : elementorlink

    return <MenuItemSingle 
        linktext={title} 
        link={showElementorlink} 
    />
}

export default MenuItem